import React, {useCallback, useEffect, useState} from "react";
import {getShipmentWithKey} from "../../../Services";
import DetailShipmentComponent from "../../Shared/DetailShipmentComponent/DetailShipmentComponent";
import {Spinner} from "reactstrap";
import {useHistory} from "react-router-dom";
import {hrefToObject} from "../../../Utils/Utils";

const ShipmentDetailComponent = () => {
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState<any>(hrefToObject());

  const history = useHistory();

  history.listen(() => {
    const p = hrefToObject();
    if (p.key) {
      setParams(p);
    }
  });

  const getShipment = useCallback( async () => {
    setData({});
    setLoading(true);
    const res = await getShipmentWithKey({shipmentKey: params.key!});
    if(res?.success){
      console.log('success:', res);
      setData(res);
    } else {
      setData(res);
    }
    setLoading(false);
  },[params.key]);

  useEffect(() => {
    if (params.key) {
      getShipment();
    }
  },[getShipment, params.key]);

  return(
    <div>
      {
        data?.shipment &&
        <div className="detail-shipment-container">
          <b className="p-2">
            Guía # {data.shipment?.consecutive}
          </b>
          <DetailShipmentComponent data={data.shipment} isShipment/>
        </div>
      }

      {
        data?.message &&
          <div className="text-center text-danger p-4">
            <h6>
              Guía no encontrada, favor contacte administración.
            </h6>
          </div>
      }

      { loading &&
        <div className="d-flex justify-content-center align-items-center mt-5">
          <Spinner color="danger" />
          <b className="text-danger mx-2">Cargando guía ...</b>
        </div>
      }

      {
        !params.key &&
        <div className="text-center text-danger p-4">
          <h6>
            Digite un numero de Guía.
          </h6>
        </div>
      }

    </div>
  );
};

export default ShipmentDetailComponent;
